module.exports = __webpack_public_path__ + "static/img/popup.3b427344.png";